import { Component } from 'react';
import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

export default class Avatar extends Component {
  render() {
    var imageUrl = this.props.imageUrl;
    var avatarInitials = this.props.initials;

    let className = cx({
      avatar: true,
    });

    //Image
    let image;
    if (imageUrl) {
      image = <img src={imageUrl} alt="Avatar" />;
    }
    let initials;
    if (avatarInitials) {
      initials = <span>{avatarInitials}</span>;
    }

    return (
      <div className={classnames(className)}>
        {image}
        {initials}
      </div>
    );
  }
}
